module.exports = __webpack_public_path__ + "static/media/audio-description.fb21782d.svg";